import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SessionExpiredModalPage } from './session-expired-modal.page';

@NgModule({
  declarations: [SessionExpiredModalPage],
  imports: [CommonModule, IonicModule],
  exports: [SessionExpiredModalPage],
})
export class SessionExpiredModalPageModule {}
